import { TradingRepo as tradingRepo } from "../../trading/trading.repo";
import { TradeSheet } from "../../trading/models/tradeSheet";
import { StringUtilities as stringUtilities } from "../../common/string.utilities";
import { TradeOrder } from "../../trading/models/tradeOrder";

class AdminTradeSheetsController implements angular.IOnInit {
  public pendingTradeSheets: Array<TradeSheet>;
  public sentTradeSheets: Array<TradeSheet>;
  public closedTradeSheets: Array<TradeSheet>;
  public isLoading = false;
  public requests = 0;

  public selectedManager: { id: number; name: string };
  public portfolioManagers: Array<{ id: number; name: string }>;

  public availableStatuses: Array<string> = [];
  public selectedStatusFilter: string;

  /** @ngInject */
  constructor(
    private tradingRepo: tradingRepo,
    private $window: angular.IWindowService,
    private notifyjs,
    private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService,
    private $anchorScroll: angular.IAnchorScrollService
  ) {}

  $onInit() {
    // that.$anchorScroll.yOffset = -200;
    this.updateTradeSheets();
    this.getPortfolioManagers();
  }

  public getShortName(text: string) {
    // return stringUtilities.truncateText(text, 20);
    return text;
  }

  getPortfolioManagers() {
    this.tradingRepo.getPortfolioManagers().then(
      (res) =>
        (this.portfolioManagers = (res.data as Array<any>).map((m) => ({
          id: m.id,
          name: m.name,
        })))
    );
  }

  updateTradeSheets() {
    let that = this;
    that.isLoading = true;
    that.requests++;

    let id;
    if (this.selectedManager) {
      id = this.selectedManager.id;
    }

    return that.tradingRepo
      .getAdminTradeSheets(id)
      .then((res) => {
        var data = res.data as Array<any>;

        that.pendingTradeSheets = new Array();
        that.sentTradeSheets = new Array();
        that.closedTradeSheets = new Array();

        var tradeSheets = data.map((d) => new TradeSheet(d));
        tradeSheets.sort((ts1, ts2) =>
          ts1.dateGenerated < ts2.dateGenerated ? 1 : -1
        );
        tradeSheets.forEach((ts) => {
          if (ts.dateClosed) {
            that.closedTradeSheets.push(ts);
            if (that.availableStatuses.indexOf(ts.status) === -1) {
              that.availableStatuses.push(ts.status);
            }
          } else if (ts.dateSent != null) {
            that.sentTradeSheets.push(ts);
          } else if (ts.dateSubmitted != null) {
            that.pendingTradeSheets.push(ts);
          }
        });
      })
      .catch((err) => {
        this.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  sendTradeSheet($event: angular.IAngularEvent, tradeSheetId: number) {
    $event.stopPropagation();
    // Mark the trade sheet as sent to broker.
    // We are actually not sending anything.
    let that = this;
    that.isLoading = true;
    that.requests++;
    return that.tradingRepo
      .sendTradeSheet(tradeSheetId)
      .then((res) => {
        that.updateTradeSheets();
      })
      .catch((err) => {
        this.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  markTradeSheetAsDone($event: angular.IAngularEvent, tradeSheet: TradeSheet) {
    $event.stopPropagation();
    // Mark the trade sheet as completed.
    let that = this;
    const tempScope = that.$rootScope.$new(true) as any;
    tempScope.tradeSheet = tradeSheet;
    that.$mdDialog
      .show({
        template: `<complete-trade-sheet-dialog trade-sheet="tradeSheet" ></complete-trade-sheet-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        that.updateTradeSheets();
      });
  }

  cancelTradeSheet($event: angular.IAngularEvent, tradeSheet: TradeSheet) {
    $event.stopPropagation();
    // Cancel the tradeSheet
    let that = this;
    const tempScope = that.$rootScope.$new(true) as any;
    tempScope.tradeSheet = tradeSheet;
    that.$mdDialog
      .show({
        template: `<cancel-trade-sheet-dialog trade-sheet="tradeSheet" ></cancel-trade-sheet-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        that.updateTradeSheets();
      });
  }

  downloadTradeSheet($event: angular.IAngularEvent, tradeSheetId: number) {
    $event.stopPropagation();

    let that = this;
    that.isLoading = true;
    that.requests++;
    return that.tradingRepo
      .getDownloadLinkAsAdmin(tradeSheetId)
      .then((res) => {
        // var tradeFile = res.data as any;
        // that.$window.open(tradeFile.url, '_blank');
        let tradeFiles = res.data as Array<any>;
        tradeFiles.forEach((tradeFile) => {
          that.$window.open(tradeFile.url, "_blank");
        });
      })
      .catch((err) => {
        this.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  showTradeSheetOrders(tradeSheet: TradeSheet) {
    let that = this;
    tradeSheet.showOrders = !tradeSheet.showOrders;
    if (
      tradeSheet.securityOrders != null &&
      tradeSheet.securityOrders.length > 0
    ) {
      return;
    }
    that.isLoading = true;
    that.requests++;
    return that.tradingRepo
      .getTradeSheetOrders(tradeSheet.id)
      .then((res) => {
        // Get all orders from the trade sheet
        var orders = res.data as Array<any>;
        // Group orders by security
        var ordersBySecurity = orders.reduce((prev, cur) => {
          if (prev.has(cur.security.name)) {
            prev.get(cur.security.name).orders.push(cur);
          } else {
            prev.set(cur.security.name, {
              security: cur.security,
              orders: [cur],
            });
          }
          return prev;
        }, new Map<string, any>()) as Map<string, any>;

        let values = ordersBySecurity.values();
        let secOrder: any = null;
        while ((secOrder = values.next().value)) {
          // Get the count
          secOrder.count = secOrder.orders.length;
          // Count completed
          secOrder.countCompleted = 0;
          secOrder.sellTotal = 0;
          secOrder.buyTotal = 0;
          secOrder.buyProcessed = 0;
          secOrder.sellProcessed = 0;

          secOrder.orders.forEach((order) => {
            secOrder.countCompleted += that.checkOrder(order) ? 1 : 0;
            secOrder.sellTotal += order.quantity < 0 ? order.quantity : 0;
            secOrder.buyTotal += order.quantity > 0 ? order.quantity : 0;
            secOrder.sellProcessed +=
              order.quantity < 0
                ? order.processedQuantity
                  ? order.processedQuantity
                  : 0
                : 0;
            secOrder.buyProcessed +=
              order.quantity > 0
                ? order.processedQuantity
                  ? order.processedQuantity
                  : 0
                : 0;
            secOrder.comment = order.comment;
          }, 0);

          // Sort orders by name
          secOrder.orders.sort((a, b) =>
            a.clientName > b.clientName ? 1 : -1
          );

          tradeSheet.securityOrders.push(secOrder);
          tradeSheet.securityOrders.sort((a, b) =>
            a.security.name > b.security.name ? 1 : -1
          );
        }
      })
      .catch((err) => {
        this.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  save(tradeSheet: TradeSheet, securityOrder: any) {
    let that = this;
    that.isLoading = true;

    let orderUpdates: any = new Array();

    securityOrder.orders.forEach((order) => {
      if (order.updateQuantity > 0) {
        orderUpdates.push({
          updateQuantity: order.updateQuantity,
          tradeId: order.tradeId,
          comment: securityOrder.comment,
        });
      }
    });

    that.requests++;
    return that.tradingRepo
      .sendOrderUpdates(tradeSheet.id, orderUpdates)
      .then((res) => {
        // Update trade sheets: We want to see the latest stats for this tradesheet that we have updated.
        return that.updateTradeSheets();
      })
      .then(() => {
        // Get orders for trade sheet
        let updateTradeSheet = that.sentTradeSheets.find(
          (ts) => ts.id == tradeSheet.id
        );
        return that.showTradeSheetOrders(updateTradeSheet);
      })
      .then(() => {
        let updateTradeSheet = that.sentTradeSheets.find(
          (ts) => ts.id == tradeSheet.id
        );
        // Make sure that the security that was updated is displayed.
        let updatedSecOrder = updateTradeSheet.securityOrders.find(
          (secOrd) => secOrd.security.name == securityOrder.security.name
        );
        updatedSecOrder.detail = true;
        that.$anchorScroll(
          `SecurityRef-${updateTradeSheet.id}-${securityOrder.security.id}`
        );
      })
      .catch((err) => {
        that.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  saveAllChanges(tradeSheet: TradeSheet) {
    let that = this;
    that.isLoading = true;

    let orderUpdates: any = new Array();
    tradeSheet.securityOrders.forEach((securityOrder) => {
      securityOrder.orders.forEach((order) => {
        if (order.updateQuantity > 0) {
          orderUpdates.push({
            updateQuantity: order.updateQuantity,
            tradeId: order.tradeId,
            comment: securityOrder.comment,
          });
        }
      });
    });
    that.requests++;
    return that.tradingRepo
      .sendOrderUpdates(tradeSheet.id, orderUpdates)
      .then((res) => {
        return Promise.all(
          tradeSheet.securityOrders.map((securityOrder) =>
            this.saveComment(tradeSheet, securityOrder)
          )
        ).then((res) => res);
      })
      .then((res) => {
        // Update trade sheets: We want to see the latest stats for this tradesheet that we have updated.
        return that.updateTradeSheets();
      })
      .then(() => {
        // Get orders for trade sheet
        let updateTradeSheet = that.sentTradeSheets.find(
          (ts) => ts.id == tradeSheet.id
        );
        return that.showTradeSheetOrders(updateTradeSheet);
      })
      .catch((err) => {
        that.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  completeTrades(tradeSheet: TradeSheet) {
    let that = this;
    that.isLoading = true;

    let orderUpdates: any = new Array();
    let selectedTradesToComplete = tradeSheet.securityOrders.filter(
      (order) => order.toComplete == true
    );
    selectedTradesToComplete.forEach((securityOrder) => {
      securityOrder.orders.forEach((order) => {
        let amountToComplete = this.checkOrderDiff(order);
        if (amountToComplete > 0) {
          orderUpdates.push({
            updateQuantity: amountToComplete,
            tradeId: order.tradeId,
            comment: securityOrder.comment,
          });
        }
      });
    });
    that.requests++;
    return that.tradingRepo
      .sendOrderUpdates(tradeSheet.id, orderUpdates)
      .then((res) => {
        // Update trade sheets: We want to see the latest stats for this tradesheet that we have updated.
        return that.updateTradeSheets();
      })
      .then(() => {
        // Get orders for trade sheet
        let updateTradeSheet = that.sentTradeSheets.find(
          (ts) => ts.id == tradeSheet.id
        );
        return that.showTradeSheetOrders(updateTradeSheet);
      })
      .catch((err) => {
        that.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  saveComment = (tradeSheet: TradeSheet, securityOrder) => {
    this.tradingRepo
      .updateSecurityCommentForTradeSheet(
        tradeSheet.id,
        securityOrder.security.id,
        securityOrder.comment
      )
      .then(() => {
        this.$anchorScroll(
          `SecurityRef-${tradeSheet.id}-${securityOrder.security.id}`
        );
      })
      .catch((err) => {
        this.notifyjs(err.data);
      })
      .finally(() => {
        this.isLoading = false;
      });
  };

  checkOrder(tradeOrder: any) {
    if (Math.abs(tradeOrder.quantity) == tradeOrder.processedQuantity) {
      return true;
    }
    return false;
  }

  checkOrderDiff(tradeOrder: any) {
    return (
      Math.abs(tradeOrder.quantity) -
      (tradeOrder.processedQuantity ? tradeOrder.processedQuantity : 0)
    );
  }

  cancel(securityOrder: any) {
    securityOrder.orders.forEach((order) => {
      order.update = null;
      order.showUpdates = false;
    });
    securityOrder.search = null;
    securityOrder.edit = false;
  }

  showTradeSheetStats(tradeSheet: TradeSheet, excludeProgress?: boolean) {
    if (excludeProgress) {
      let template =
        `Portfolios: \t${tradeSheet.portfolioCount}` +
        `\nOrders: \t\t${tradeSheet.orderCount}` +
        `\nBuy Quantity: \t${tradeSheet.buyQuantityOrdered}` +
        `\nSell Quantity: \t${tradeSheet.sellQuantityOrdered}`;

      return template;
    } else {
      let template =
        `Portfolios completed: \t${tradeSheet.portfoliosCompleted} of ${tradeSheet.portfolioCount}` +
        `\nOrders completed: \t${tradeSheet.ordersCompleted} of ${tradeSheet.orderCount}` +
        `\nBuy processed: \t\t${tradeSheet.buyQuantityProcessed} of ${tradeSheet.buyQuantityOrdered}` +
        `\nSell processed: \t\t${tradeSheet.sellQuantityProcessed} of ${tradeSheet.sellQuantityOrdered}`;

      return template;
    }
  }

  showOrderUpdates(tradeSheet: TradeSheet, tradeOrder: TradeOrder) {
    let that = this;

    tradeOrder.showUpdates = !tradeOrder.showUpdates;
    if (tradeOrder.updates != null) {
      return;
    }
    that.isLoading = true;
    that.requests++;
    return that.tradingRepo
      .getOrderUpdates(tradeSheet.id, tradeOrder.tradeId)
      .then((res) => {
        tradeOrder.updates = res.data as Array<any>;
      })
      .catch((err) => {
        that.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }

  deleteOrderUpdate(
    tradeSheet: TradeSheet,
    tradeOrder: TradeOrder,
    orderUpdate: any
  ) {
    let that = this;

    that.isLoading = true;
    that.requests++;
    return that.tradingRepo
      .deleteOrderUpdate(tradeSheet.id, tradeOrder.tradeId, orderUpdate.id)
      .then((res) => {
        return that.updateTradeSheets();
      })
      .then(() => {
        let updateTradeSheet = that.sentTradeSheets.find(
          (ts) => ts.id == tradeSheet.id
        );
        return that.showTradeSheetOrders(updateTradeSheet);
      })
      .then(() => {
        let updateTradeSheet = that.sentTradeSheets.find(
          (ts) => ts.id == tradeSheet.id
        );
        // Make sure that the security that was updated is displayed.
        let updatedSecOrder = updateTradeSheet.securityOrders.find(
          (secOrd) => secOrd.security.name == tradeOrder.security.name
        );
        let updateOrder = updatedSecOrder.orders.find(
          (order) => order.tradeId == tradeOrder.tradeId
        );
        updatedSecOrder.edit = true;
        that.showOrderUpdates(updateTradeSheet, updateOrder).then(() => {
          that.$anchorScroll(
            `OrderRef-${updateTradeSheet.id}-${updateOrder.tradeId}`
          );
        });
      })
      .catch((err) => {
        that.notifyjs(err.data);
      })
      .finally(() => {
        that.isLoading = false;
        that.requests--;
      });
  }
}

export const adminTradeSheets: angular.IComponentOptions = {
  template: require("./adminTradeSheets.html"),
  controller: AdminTradeSheetsController,
};



// WEBPACK FOOTER //
// ./src/app/tradingadmin/tradesheets/admintradesheets.ts